import React from 'react';

export default ({ width, height, fill }) => (
	<svg fill={fill} version="1.1" x="0px" y="0px" width={width} height={height} viewBox="0 0 512 512" xmlSpace="preserve">
		<g transform="translate(150 0)">
			<line fill="none" stroke={fill} strokeWidth="20" x1="17.7" y1="19" x2="256" y2="256"/>
			<line fill="none" stroke={fill} strokeWidth="20" x1="256" y1="256" x2="17.7" y2="489.3"/>
		</g>
	</svg>
);



// WEBPACK FOOTER //
// ./src/components/icons/ArrowRight.js